import Hero from './Hero';
import HowTo from './HowTo';
import Pricing from './Pricing';
import Testimonials from './Testimonials';
import Closer from './Closer';
import Benefit from './Benefit';

export { Hero, HowTo, Pricing, Testimonials, Closer, Benefit };
